import React, {useEffect, useState} from 'react';
import {getStateByPath} from "../../../../redux/selectors";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle, Spinner} from "reactstrap";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {
    ADD_STATE, REMOVE_STATE, setApp,
    setFilter,
    setForm,
    setItem, setLoading, setMapConfig,
    setTableParams, setUdn,
    setViewMode
} from "../../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {placeService} from "../../../../jwt/_services/hotel/placeService";
import {ModalFormContainer} from "../../../../components/confirmAlert/ModalFormContainer";
import HomePlaceForm from "./_form";

const HomePlaceSection = (props) => {
    const path = props?.path + '/place';
    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const {  app, udn, mapConfig } = parentComponentState?.data || {};
    const {  listDomainObjects } = componentState?.data || [];
    const {  domainObject, loading } = componentState?.data || {};

    const [image, setImage] = useState( null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect( () => {
        if( !app?.id || !udn?.id )
            return

        // Cargar datos de UDN

        const filter = {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                udn : { id : udn.id },
                code: udn?.code?.toLowerCase()
            }
        }

        props.setApp(path, app);
        props.setUdn(path, udn);
        genericIndexedActions.search(path, placeService, 0, 1, filter)

    }, [ app, udn ]);

    useEffect(() => {
        if (!listDomainObjects)
            return

        props.setItem(path, listDomainObjects[0]);
    }, [listDomainObjects]);

    useEffect(() => {
        if (!mapConfig)
            return

        props.setMapConfig(path, mapConfig);
    }, [mapConfig]);


    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(HomePlaceForm, { path, data, Form: HomePlaceForm })
    }

    return <Card className={'home-udn-place'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <>
                <h2>{'Ficha de detalle'}</h2>
                <h5 className={'card-modal-uid'}> {'     uid: ' + (domainObject?.uid || '')}</h5>
            </>
            <div className="top-right">
                <GenericButton
                    style={'table'}
                    label={'Editar'}
                    toolTip={'Editar'}
                    icon={'fa-pen'}
                    permission={'edit'}
                    onClick={_ => editItem(domainObject)}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            {
                loading ? <Spinner animation="border"/> : <>
                    <img className={'home-place-logo'} src={domainObject?.mediaUrl} alt={domainObject?.title}/>
                    <br/>
                    <h4>{domainObject?.langs?.find(l => l?.lang?.showOrder === 1)?.shortDescription || ''}</h4>
                    <br/>
                </>
            }
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
    setApp,
    setUdn,
    setMapConfig
})
export default connect(mapStateToProps, mapActionsToProps)(HomePlaceSection)